/**
 * @generated SignedSource<<58bfe63e5b1f5ce1f7c93e7225ea456d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type Nav4ProjectMenuItem$data = {
  readonly projectType: JiraProjectType;
  readonly status: JiraProjectStatus;
  readonly " $fragmentSpreads": FragmentRefs<"JiraBusinessProjectMenu" | "JpdProjectMenu" | "JsmProjectMenu" | "JswProjectMenu">;
  readonly " $fragmentType": "Nav4ProjectMenuItem";
};
export type Nav4ProjectMenuItem$key = {
  readonly " $data"?: Nav4ProjectMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4ProjectMenuItem",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW",
      "path": "projectType"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraBusinessProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JsmProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JpdProjectMenu"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswProjectMenu"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5a26636517acdf87ef9fc5b133d01d56";

export default node;
